import React from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';

const Loader = () => {
	return (
		<Stack alignItems='center' justifyContent='center' minHeight={'98vh'} minWidth={'100vw'}>
			<CircularProgress />
		</Stack>
	);
};

export default Loader;
